<template>
  <div>
    <el-dialog
      title="导入分配记录"
      :visible.sync="dialogVisible"
      width="1000px"
      top="15px"
      @close="close"
    >
      <el-button type="primary" @click="downLoadModel">
        下载导入模板
      </el-button>

      <el-upload
        action=""
        multiple
        :show-file-list="false"
        :http-request="uploadaction"
        style="display: inline-block;margin: 0 10px"
      >
        <el-button type="primary">
          选择文件上传
        </el-button>
      </el-upload>
      <h3 style="margin-top:10px;margin-bottom:10px">
        错误信息
      </h3>
      <el-table :data="errData" border style="width: 100%">
        <el-table-column prop="number" label="行号" align="left" fixed="left" width="50" />
        <el-table-column prop="msg" label="错误提示" align="left">
          <template v-slot="{row}">
            <span style="color:red">{{ row.msg }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div v-loading="tableLoading" class="tableBody" style="margin-top:10px">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="id" label="序号" align="left" fixed="left" width="50" />
          <el-table-column prop="contractNum" label="合同号" align="left" />
          <el-table-column prop="partialInvoiceNum" label="分批申请单号" align="left" />
          <el-table-column prop="teleTransferNum" label="电汇底单编号" align="left" />
          <el-table-column prop="assignedAmount" label="本次分配金额" align="right" header-align="left" />
        </el-table>
      </div>
      <div style="margin-top:20px;margin-bottom:20px">
        本次分配金额合计：{{ allAmount.toFixed(2) }}元
      </div>
      <div class="footer-btn">
        <el-button type="default" @click="calcel">
          取消导入
        </el-button>
        <el-button type="primary" :loading="loading" @click="sureImport">
          确定导入
        </el-button>
      </div>
      <a ref="downTag" :href="downURL" target="_blank" />
    </el-dialog>
  </div>
</template>

<script>
import { getDocumentAllocationData, checkingDocumentAllocationData, downloadImport } from '@/API';
export default {
  data () {
    return {
      dialogVisible: this.dialogFormVisible,
      tableLoading: false,
      tableData: [],
      errData: [],
      downURL: '',
      loading: false,
      allAmount: 0
    };
  },
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false
    }
  },
  components: {
  },
  methods: {
    close () {
      this.dialogVisible = false;
      this.tableData = [];
      this.errData = [];
      this.allAmount = 0;
    },
    calcel () {
      this.close();
    },
    sureImport () {
      // 导入
      this.loading = true;
      checkingDocumentAllocationData(this.tableData).then((res) => {
        this.loading = false;
        let json = res.data;
        if (json.status === '200') {
          this.dialogVisible = false;
          this.$message.success('导入成功');
        } else {
          this.errData = json.data;
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    // 下载
    downLoadModel () {
      downloadImport().then((res) => {
        const content = res.data;
        const blob = new Blob([content]);// 构造一个blob对象来处理数据
        const fileName = '分配模板' + new Date().toLocaleString() + '.xlsx';
        // 对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
        // IE10以上支持blob但是依然不支持download
        if (window.navigator.msSaveOrOpenBlob) { // 支持a标签download的浏览器
          navigator.msSaveBlob(blob, fileName);
        } else { // 其他浏览器
          const link = document.createElement('a');// 创建a标签
          link.download = fileName;// a标签添加属性
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();// 执行下载
          URL.revokeObjectURL(link.href); // 释放url
          document.body.removeChild(link);// 释放标签
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    // 文件上传
    uploadaction (upload) {
      const form = new FormData(); // 创建form对象
      form.append('file', upload.file);
      getDocumentAllocationData(form).then((res) => {
        let json = res;
        if (json.status === 200) {
          this.allAmount = 0;
          this.tableData = json.data.data;
          this.errData = [];
          // 设置分配金额
          this.tableData.forEach((item) => {
            this.allAmount += item.assignedAmount;
          });
        } else {
          this.tableData = [];
          this.allAmount = 0;
        }
      }).catch(() => {

      });
    }

  },
  watch: {
    dialogFormVisible (val) {
      this.dialogVisible = val;
    },
    dialogVisible (val) {
      this.$emit('on-status-dialog', val);
    }
  },
  mounted () {

  }

};
</script>

<style>
.footer-btn{
  display: flex;
  justify-content: flex-end;

}
</style>
